export const CAMPAIGN_PAGE = Object.freeze({
  OWNED_SUMMARY: 'OWNED_SUMMARY',
  INSTAGRAM: 'INSTAGRAM',
  INSTAGRAM_UGC: 'INSTAGRAM_UGC',
  INSTAGRAM_STORIES: 'INSTAGRAM_STORIES',
  TIKTOK: 'TIKTOK',
  TIKTOK_UGC: 'TIKTOK_UGC',
  FACEBOOK: 'FACEBOOK',
  PINTEREST: 'PINTEREST',
  YOUTUBE: 'YOUTUBE',
  X: 'X',

  CREATOR_SUMMARY: 'CREATOR_SUMMARY',
  CREATOR_DELIVERABLES: 'CREATOR_DELIVERABLES',

  SOCIAL_ADS_SUMMARY: 'SOCIAL_ADS_SUMMARY',
  META_ADS: 'META_ADS',
  TIKTOK_ADS: 'TIKTOK_ADS',
  GOOGLE_ANALYTICS: 'GOOGLE_ANALYTICS',
});

export const METRIC_SOURCE = Object.freeze({
  CUSTOM_METRICS: 'custom_metrics',
  DASHBOARDS: 'dashboards',
  CREATOR_INSIGHTS: 'creator_insights',
});

export const DUPLICATE_CAMPAIGN_CONTENT = Object.freeze({
  POSTS: 'POSTS',
  CREATORS: 'CREATORS',
  ADS: 'ADS',
});

export type DuplicateCampaignContent =
  (typeof DUPLICATE_CAMPAIGN_CONTENT)[keyof typeof DUPLICATE_CAMPAIGN_CONTENT];
